// extracted by mini-css-extract-plugin
export default {"paper_container":"Authors_paper_container__PB9Ez","header_title":"Authors_header_title__-mIeG","search_add_container":"Authors_search_add_container__tcnWz"};